import { fetcher } from '@common/utils/fetcher';

export type PostUploadParams = {
  file: File;
};

export type PostUploadResponse = {
  url: string;
};

export const postUpload = ({ file }: PostUploadParams) => {
  const form = new FormData();
  form.append('photo', file);

  return fetcher<PostUploadResponse>({
    url: '/upload',
    method: 'POST',
    data: form,
  });
};
